module.exports = __webpack_public_path__ + "img/select-arrow.036002e0.svg";